export const Themes = {
  PRIMARY: 'PRIMARY',
  SIMPLE: 'SIMPLE',
};

export const Modes = {
  BASIC: 'BASIC',
  DUAL: 'DUAL',
  OVERVIEW: 'OVERVIEW',
};